import { render, staticRenderFns } from "./BoardReply.vue?vue&type=template&id=15229ac8&scoped=true"
import script from "./BoardReply.vue?vue&type=script&lang=ts"
export * from "./BoardReply.vue?vue&type=script&lang=ts"
import style0 from "./BoardReply.vue?vue&type=style&index=0&id=15229ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15229ac8",
  null
  
)

export default component.exports